import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhoIsForSection() {
  const bullets = ['Bajones de energía que ya sientes "normales"', 'Niebla mental después de comer', 'Rigidez al despertar que atribuyes a la edad', 'Antojos de azúcar que no se sienten como "falta de voluntad"', 'Etiquetas confusas al comprar en EE. UU.'];
  return <section className="py-16 md:py-20 px-4 bg-[#141414]" data-id="element-139">
      <div className="max-w-3xl mx-auto" data-id="element-140">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-10" data-id="element-141">
          Si esto te suena familiar, empieza aquí.
        </h2>

        <div className="grid gap-4" data-id="element-142">
          {bullets.map((bullet, idx) => <div key={idx} className="flex items-start gap-4 p-4 rounded-lg hover:bg-[#1a1a1a] transition-colors duration-300 border border-transparent hover:border-[#2a2a2a]" data-id="element-143">
              <CheckCircle2 className="w-6 h-6 text-[#C9A84C] shrink-0 mt-0.5" data-id="element-144" />
              <p className="text-lg text-[#ccc]" data-id="element-145">{bullet}</p>
            </div>)}
        </div>
      </div>
    </section>;
}